import { render, staticRenderFns } from "./dingbudaohang.vue?vue&type=template&id=b41912fc&scoped=true&"
import script from "./dingbudaohang.vue?vue&type=script&lang=js&"
export * from "./dingbudaohang.vue?vue&type=script&lang=js&"
import style0 from "./dingbudaohang.vue?vue&type=style&index=0&id=b41912fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41912fc",
  null
  
)

export default component.exports